import React from 'react'
import { MDBTable, MDBTableBody } from 'mdbreact';
import BotonesFormulario from '../componentes/BotonesFormulario'
import HeaderTabla from '../componentes/HeaderTabla'
//import TraeNombre from '../hooks/useTraeNombre'
import { TraeNombre } from '../hooks/Funciones'

const VerTarifas = ({ data, seleccionaRegistro, baseUrl, tiposIngresos }) => {

	return (
		<MDBTable hover responsive>
			<HeaderTabla array={['Id','Nombre', 'Incono', 'Pts Mínimo', 'Pts Máximo','']} />
			<MDBTableBody>

				{data.map((item, index) => {
					return (
						<tr key={index} className="tabla_productos">
							<td>{item.id}</td>
							<td>{item.nombre}</td>
							<td>{item.icono}</td>
							<td>{item.limitemenor}</td>
							<td>{item.limitemayor}</td>
							<td className="tabla_funciones">
								<BotonesFormulario SeleccionarCategoria={seleccionaRegistro} item={item} Roll={'Admin'} />
							</td>
						</tr>
					)
				})}

			</MDBTableBody>
		</MDBTable>
	)
}

export default VerTarifas